import { JobStatuses } from '../constants/job';
import { JobStatus } from '../models/job';

export function isJobStatus(value): value is JobStatus {
  return value in JobStatuses;
}
